import { Card, CardContent, CardHeader } from '@/components/ui/Card'
import { SectionEyebrow } from '@/components/ui/SectionEyebrow'
import { LockedRegion } from '@/components/ui/LockedRegion'
import { Text } from '@/components/ui/Text'
import { Day0ReadinessChecklist, type ChecklistItem } from './Day0ReadinessChecklist'

interface Day0CurrentStageCardProps {
  stageLabel: string
  /**
   * null → checklist region replaced by LockedRegion ("Coming in next update" — a genuine BE gap,
   * granular rows are coming but not built yet).
   * undefined (or omitted) → checklist region omitted ENTIRELY — for a persona that has no
   * checklist-row concept at all (C13/T0062: the agency board always passed null here, which reads
   * as "coming soon" for something that isn't coming; there is nothing to distinguish it from the
   * client's genuine BE gap without this second state).
   */
  checklistItems?: ChecklistItem[] | null
  /** null → footnote section omitted entirely */
  footnoteText: string | null
}

export function Day0CurrentStageCard({
  stageLabel,
  checklistItems,
  footnoteText,
}: Day0CurrentStageCardProps) {
  return (
    <Card data-testid="day0-current-stage-card">
      <CardHeader className="flex-row items-center py-4">
        <div className="flex flex-col gap-0.5">
          <SectionEyebrow>CURRENT STAGE</SectionEyebrow>
          <Text variant="title-md">{stageLabel}</Text>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-4">
          {checklistItems === undefined
            ? null
            : checklistItems != null && checklistItems.length > 0 ? (
            <Day0ReadinessChecklist items={checklistItems} />
          ) : (
            <LockedRegion chipLabel="Coming in next update" />
          )}

          {footnoteText && (
            <div className="rounded-md bg-surface-muted p-3">
              <Text variant="body-sm" color="muted">
                {footnoteText}
              </Text>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
